var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgGooglecloud = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 71,
    viewBox: "0 0 71 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logos/googlecloud-original"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M44.7055 22.3526H44.9273L44.8164 22.2417L52.5816 14.4765V14.3101C46.0366 8.54165 36.9957 6.54488 28.6204 9.04084C20.245 11.5368 13.811 18.1927 11.4814 26.6235C11.5923 26.5681 11.7587 26.5126 11.9251 26.5126C14.8094 24.6267 18.2482 23.5174 21.8535 23.5174C23.0738 23.5174 24.2386 23.6284 25.4033 23.8502C25.4588 23.7948 25.5143 23.7948 25.5697 23.7948C30.5617 18.3036 38.9925 17.638 44.7609 22.3526H44.7055Z",
    fill: "#EA4535"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M59.9585 26.5127C58.6828 21.7981 56.0205 17.5272 52.3043 14.2548L44.3726 22.1309C47.7006 24.8487 49.6419 28.9532 49.531 33.2241V34.6107C58.9047 34.6107 58.9047 48.5881 49.531 48.5881H35.4426V59.6813H35.3872L35.4426 59.7922H49.531C57.629 59.8477 64.7841 54.6339 67.1691 46.9796C69.5541 39.3253 66.6144 31.0054 59.9585 26.5127Z",
    fill: "#557EBF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M21.6317 59.8477H36.2192V48.6436H21.6317C20.5778 48.6436 19.5794 48.4217 18.6365 48.0334L10.2057 56.1315V56.2424C13.5337 58.6274 17.5272 59.9031 21.6871 59.9031L21.6317 59.8477Z",
    fill: "#36A852"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M22.2973 23.2401C14.0329 23.2956 6.71136 28.3984 4.049 35.8863C1.38664 43.4297 4.049 51.6941 10.594 56.5751L19.2466 48.3107C14.4766 46.2584 13.3673 40.2681 17.028 36.7738C20.6888 33.224 26.9009 34.3333 29.0641 38.8815L37.7168 30.6171C34.056 26.0134 28.343 23.2956 22.2973 23.351V23.2401Z",
    fill: "#F9BC15"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgGooglecloud);
export default ForwardRef;